<template>
  <div>
    <panel title="Jednostki oświatowe">
      <check-permission slot="toolbar" entity-type="structureNode" permissions="STRUCTURE_NODE.ADD">
        <button class="btn btn-primary" @click="addNode({ id: null })">
          <i class="fal fa-fw fa-plus" />
          Dodaj węzeł podstawowy
        </button>
      </check-permission>

      <async-tree
        entity-type="structureNode"
        permission-name="STRUCTURE_NODE"
        :options="options"
        :root-structure="rootStructure"
        @add-node="addNode"
        @update="beforeUpdate"
        @delete="showDeleteDialog"
        @tree="setTree"
      >
        <template slot="actions" slot-scope="{ node }">
          <check-permission v-if="checkIfCouldChangeSingle(node)" permissions="STRUCTURE_NODE.UPDATE">
            <tooltip text="Zmień status szkoły">
              <button
                class="btn btn-light btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 mb-2"
                @click="prepareNode(node)"
              >
                <i class="fa fa-university" />
              </button>
            </tooltip>
          </check-permission>
        </template>
      </async-tree>
    </panel>

    <structure-node-modal
      :id="idToEdit"
      :parent-id="parentId"
      :show="showModal"
      @save="add"
      @close="hideNodeModal"
      @update="update"
    />

    <confirm-modal
      :show="confirmModalVisible"
      :text="confirmModalText"
      :submit-data="submitData"
      @submit="changeIsSingle"
      @close="hideConfirmModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Tooltip from '@/components/tooltip/Tooltip';
import StructureNodeModal from '@/components/modals/StructureNodeModal.vue';
import Panel from '@/components/panel/Panel.vue';
import AsyncTree from '@/components/tree/AsyncTree.vue';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { treeMixin } from '@/mixins/tree';
import { structureNodeResource } from '@/resources/structureNode.resource';
import { confirmModalMixin } from '@/mixins/confirmModal';
import ConfirmModal from '@/components/modals/ConfirmModal';

const messages = {
  getError: Errors.STRUCTURE_CANNOT_GET,
  added: Successes.STRUCTURE_ADDED,
  addError: Errors.STRUCTURE_CANNOT_ADD,
  updated: Successes.STRUCTURE_UPDATED,
  updateError: Errors.STRUCTURE_CANNOT_UPDATE,
  deleted: Successes.STRUCTURE_DELETED,
  deleteError: Errors.STRUCTURE_CANNOT_DELETE
};

// @vuese
// Drzewo struktury
// @group Structure
export default {
  components: { Panel, StructureNodeModal, AsyncTree, Tooltip },
  mixins: [treeMixin('structureNode', messages, 'name', structureNodeResource, 'childrenIds'), confirmModalMixin],
  data() {
    return {
      confirmModalText: ''
    };
  },
  methods: {
    // @vuese
    // Sprawdza czy można zmienić status szkoły
    checkIfCouldChangeSingle(node) {
      return node.parent && node.parent.children.length === 1;
    },
    // @vuese
    // Zmienia status szkoły
    changeIsSingle(data) {
      return this.$store
        .dispatch('structureNode/updateIsSingle', data)
        .then(() => this.notifySuccess(Successes.STRUCTURE_UPDATED))
        .catch(() => this.notifyError(Errors.STRUCTURE_CANNOT_UPDATE));
    },

    // @vuese
    // Przygotowuje węzeł do zmiany statusu
    prepareNode(node) {
      return this.$store
        .dispatch('structureNode/get', node.id)
        .then(node => {
          this.confirmModalText = node.isSingle
            ? 'Potwierdź zmianę statusu szkoły na jednostkę składową w zespole szkół.'
            : 'Potwierdź zmianę statusu szkoły na samodzielną.';
          this.showConfirmModal({ id: node.id, isSingle: !node.isSingle });
        })
        .catch(() => this.notifyError(Errors.STRUCTURE_CANNOT_GET));
    }
  }
};
</script>
